module.exports = __webpack_public_path__ + "media/images/hero_images/index-1200-1e95dd33e8e5c30ea4c45506ae1add2e.jpg";